import { IInitialState } from "us.collection.input-output/reducers/ATG/Interfaces";

export const initialState: IInitialState = {
  atgs: {
    data: [],
    isFetching: false,
  },
};
